
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.5","height":"22.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 1670","d":"M11.25.25a11 11 0 1011 11 11 11 0 00-11-11zm0 19.937a8.937 8.937 0 118.937-8.937 8.937 8.937 0 01-8.937 8.937zm0-15.113c-.788 0-1.384.411-1.384 1.075v6.091c0 .665.6 1.075 1.384 1.075.769 0 1.384-.427 1.384-1.075V6.15c.001-.649-.615-1.076-1.384-1.076zm0 9.613a1.373 1.373 0 101.372 1.374 1.375 1.375 0 00-1.372-1.373z","stroke":"#fff","stroke-width":".5","opacity":".501"}})])
          )
        }
      }
    